import { render, staticRenderFns } from "./FichaSintomatologia.vue?vue&type=template&id=068f225c&"
import script from "./FichaSintomatologia.vue?vue&type=script&lang=js&"
export * from "./FichaSintomatologia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports